module.exports = __webpack_public_path__ + "img/receipt.7c012c63.svg";